import './TemporaryShippingAddress.less';

import { useMount } from 'ahooks';
import { AutoComplete } from 'antd';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import TextArea from 'antd/lib/input/TextArea';
import { JobFullfillmentShippingInfoInternalDistribution } from 'domains/jobconfigDomain';
import { Contact } from 'domains/orgDomain';
import { useEffect, useMemo, useState } from 'react';
import orgService from 'services/orgService';
import { addressTranslator } from 'utils/address';
import { getFullName } from 'utils/misc';

export type TemporaryShippingAddressValue = {
  toAddressLine: string;
  toCity: string;
  toCountryCode: string;
  toName: string;
  toPostalCode: string;
  toStateProvinceCode: string;
  internalDistribution?: JobFullfillmentShippingInfoInternalDistribution;
};
type Props = {
  orgId: number;
  value?: TemporaryShippingAddressValue;
  size?: SizeType;
  onChange?: (value: TemporaryShippingAddressValue) => void;
  contactPlaceholder?: string;
  addressPlaceholder?: string;
};

export const TemporaryShippingAddress = ({
  orgId,
  value,
  size,
  onChange,
  ...props
}: Props) => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  // const [contactsLoading, setContactsLoading] = useState<boolean>(false);
  const [curValue, setCurValue] = useState(value);

  const contactOptions = useMemo(() => {
    return contacts.map((contact, index) => {
      return {
        label: getFullName(contact),
        value: `${getFullName(contact)},${index}`,
        key: getFullName(contact) + index,
      };
    });
  }, [contacts]);

  const curContact = useMemo(() => {
    return contacts.find((item) => item.fullName === curValue?.toName);
  }, [contacts, curValue?.toName]);

  useEffect(() => {
    // controlled mode
    if (value !== undefined) {
      setCurValue(value);
    }
  }, [value]);

  const addressOptions = useMemo(() => {
    const addresses = curContact?.addresses || [];

    return addresses.map((address, index) => {
      const newAddress = addressTranslator.contactToAddress(address);
      const addressLabel = addressTranslator.dataToAddress(newAddress);
      return {
        label: addressLabel,
        value: addressLabel,
        key: addressLabel + index,
      };
    });
  }, [curContact?.addresses]);

  useMount(async () => {
    // setContactsLoading(true);
    const data = await orgService.getContacts(orgId);
    // setContactsLoading(false);
    setContacts(data);
  });

  return (
    <div className="temporary-shipping-address">
      <div>
        <AutoComplete
          className="temporary-shipping-address-contact-select"
          //   loading={contactsLoading}
          style={{ width: '100%' }}
          value={curValue?.toName}
          options={contactOptions}
          placeholder={props.contactPlaceholder}
          size={size}
          onChange={(val) => {
            const newValue = {
              toAddressLine: '',
              toCity: '',
              toCountryCode: '',
              toName: val.split(',')[0],
              toPostalCode: '',
              toStateProvinceCode: '',
            };

            if (value === undefined) {
              // uncontroled mode
              setCurValue(newValue);
            }
            if (onChange) {
              onChange(newValue);
            }
          }}
        ></AutoComplete>
      </div>
      <div>
        <AutoComplete
          className="temporary-shipping-address-address-select"
          //   loading={contactsLoading}
          style={{ width: '100%' }}
          value={curValue && addressTranslator.dataToAddress(curValue)}
          options={addressOptions}
          placeholder={props.addressPlaceholder}
          size={size}
          onChange={(val) => {
            const newValue = {
              ...addressTranslator.addressToData(val),
              toName: curValue?.toName || '',
            };
            setCurValue(newValue);
            if (onChange) {
              onChange(newValue);
            }
          }}
        >
          <TextArea />
        </AutoComplete>
      </div>
    </div>
  );
};
